var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCircleWhitephone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#470FDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.812 11.313c1-.75 1.75-1.25 1.625-2.25C14 8.125 13.25 4.25 10.75 5.188 9.437 5.563 7.875 6.375 7.875 8c-.188 1.563.687 3.875.687 3.875s4.25 9.75 7.5 11.625c1.438.938 2.438 1.188 4 1 1.125-.312 2.313-1.687 2.313-2.812-.188-1.375-2.063-3.5-2.563-3.75-.75-.25-1.437-.188-2.5.5-.812-.75-3.625-5-4.125-5.938-.562-.875-.375-1.187-.375-1.187z",
    fill: "#FFF",
    stroke: "#2B0985"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCircleWhitephone);
export default __webpack_public_path__ + "static/media/icon-circle-whitephone.bb436c4983f69b688c3faa68662429b6.svg";
export { ForwardRef as ReactComponent };